
<div dropdown class="dropdown facilities" [insideClick]="true" [autoClose]="true" (isOpenChange)="onDropdownToggle($event)" [hidden]="available.length === 0">
    <div dropdownToggle class="facilities-div-wrapper">
    <a  class="dropdown-link eclipsed">
        <span *ngIf="selected.length === 0">Select Facility</span>
        <span *ngIf="selected.length === 1">{{selected[0].name}}</span>
        <span *ngIf="selected.length > 1 && selected.length < available.length">Facilities: {{selected.length}}</span>
        <span *ngIf="selected.length > 0 && selected.length === available.length">All Facilities</span>

    </a>
    <span class="caret"></span>
    </div>
    <ul *dropdownMenu class="facility-dropdown dropdown-menu" role="menu">
        <li class="dropdown-header">Select Facility</li>
        <li class="dropdown-search" [hidden]="!showSearch">
            <input [(ngModel)]="searchTerm" (input)="onSearchTermChanged()" type="search" placeholder="Search..." />
        </li>
        <li role="menuitem" [hidden]="singleOnlyPage" >
            <a class="select-all dropdown-item" (click)="onSelectAll()">Select all facilities</a>
        </li>
        <li role="menuitem">
            <div class="scroll-area">
                <div class="region">
                    <div class="sub-region" *ngIf="!isSearching; else searching">
                        <div *ngFor="let facility of available" class="facility">
                            <div [class]= "'indent-' + facility.indentLevel">
                                <label [class]="isAllSelected ? 'checkbox-square' : 'checkbox'" [tooltip]="getFacilityTooltipText(facility)">
                                    <input type="checkbox" [id]="facility.id" [disabled]="(facility.selected && isOneSelected) || isFacilityDisabled(facility) || (singleOnlyPage && isCustomOrgUnit(facility))"
                                        [(ngModel)]="facility.selected" (ngModelChange)="onSelectionChange(facility)">
                                    <span></span>
                                    <span  [attr.data-facility-type]="getFacilityTypeDataAttribute(facility)" [ngClass]="{'text-muted':isFacilityDisabled(facility)}">{{facility.name}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <!-- Remove indent on searching per Amanda -->
                    <ng-template #searching>
                        <div class="sub-region" *ngIf="hasResults">
                            <div *ngFor="let facility of filtered" class="facility">
                                <label [class]="isAllSelected ? 'checkbox-square' : 'checkbox'" [tooltip]="getFacilityTooltipText(facility)">
                                    <input type="checkbox" [id]="facility.id" [disabled]="(facility.selected && isOneSelected) || isFacilityDisabled(facility) || (singleOnlyPage && isCustomOrgUnit(facility))"
                                        [(ngModel)]="facility.selected" (ngModelChange)="onSelectionChange(facility)">
                                    <span></span>
                                    <span  [attr.data-facility-type]="getFacilityTypeDataAttribute(facility)" [ngClass]="{'text-muted':isFacilityDisabled(facility)}">{{facility.name}}</span>
                                </label>
                            </div>
                        </div>
                        <div class="sub-region" *ngIf="!hasResults">
                            <div class="dropdown-item" style="text-overflow: ellipsis;">
                                No results found
                            </div>
                        </div>
                    </ng-template>
                </div>
            </div>
        </li>
    </ul>
</div>